var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6836 13.9376C15.6836 13.4405 16.0865 13.0376 16.5836 13.0376H29.7086C30.2057 13.0376 30.6086 13.4405 30.6086 13.9376C30.6086 14.4347 30.2057 14.8376 29.7086 14.8376H16.5836C16.0865 14.8376 15.6836 14.4347 15.6836 13.9376Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14C17 16.7614 14.7614 19 12 19C9.23858 19 7 16.7614 7 14C7 11.2386 9.23858 9 12 9C14.7614 9 17 11.2386 17 14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3916 26.0626C8.3916 25.5655 8.79455 25.1626 9.2916 25.1626H22.4166C22.9137 25.1626 23.3166 25.5655 23.3166 26.0626C23.3166 26.5597 22.9137 26.9626 22.4166 26.9626H9.2916C8.79455 26.9626 8.3916 26.5597 8.3916 26.0626Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 26C32 28.7614 29.7614 31 27 31C24.2386 31 22 28.7614 22 26C22 23.2386 24.2386 21 27 21C29.7614 21 32 23.2386 32 26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8b5a1a4234bdc08123acf48f550a47b7.svg";
export { ForwardRef as ReactComponent };